import { gql } from '@apollo/client';

export const GET_CLIENT_LOGO = gql`
  query GET_CLIENT_LOGO {
    currentSponsor {
      clientLogoUrl
    }
  }
`;
